import CKEditor from 'react-ckeditor-component';
import {ReactNode, useEffect, useState} from "react";
import parse from "html-react-parser";

class HtmlEditorProps {
    Text: string
    OnChange
    ReadMode: Boolean
    className
}

export default ({Text, OnChange, ReadMode,className}: HtmlEditorProps) => {
    const [data, setData] = useState<ReactNode>()
    console.log(Text);

    useEffect(() => {
        setData(Text)
        console.log(Text);
    }, [Text]);
    const config = {
        language: "fa",
        fontFamily: {
            options: [
                'default',
                'Ubuntu, Arial, sans-serif',
                'Ubuntu Mono, Courier New, Courier, monospace'
            ]
        },
    };


    const onChange = (evt) => {
        // console.log("onChange fired with event info: ", evt);
        // setData(evt.editor.getData());
        OnChange(evt.editor.getData())
        // console.log(data);
    }

    return <>
        {!ReadMode ?
            <CKEditor className={className}
                activeClass="p10"
                config={config}
                content={data}
                events={{
                    // "blur": this.onBlur,
                    // "afterPaste": this.afterPaste,
                    "change": onChange
                }}
                active={(a) => {
                    console.log(a)
                }}
            /> :
            <div className={className}>
                {parse(Text)}
            </div>
        }
    </>
}